module.exports = __webpack_public_path__ + "assets/time-error-3e33d5.svg";